import {Locales} from '@netx/core-next/locales/utils/Locales';
import {OrganizeAssetsAction} from './constants';

export const CategoriesLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.categories'),
}));

export const CategoryActionLabel = Locales((i18n) => ({
	ADD: i18n('i18n.addCategory'),
	ADD_SUBFOLDER: i18n('i18n.addSubCategory'),
	DELETE: i18n('i18n.deleteCategory'),
	EDIT: i18n('i18n.editCategory'),
	IMPORT: i18n('i18n.importToCategory'),
	SEARCH_ALL_ASSETS: i18n('i18n.listAll'),

	CREATE_PDF: i18n('i18n.createPDF'),
	CREATE_PDF_SHARE_LINK: i18n('i18n.createLink'),
	CREATE_PDF_DOWNLOAD: i18n('i18n.download'),
	DOWNLOAD: i18n('i18n.download'),
	MENU: i18n('i18n.share'),
	SHARE_LINK: i18n('i18n.createLink'),
	SHARE_FEED: i18n('i18n.createFeed'),
}));

export const CategoryCollisionManagerTitle = Locales((i18n) => ({
	TITLE: i18n('i18n.categoryCollisionManagerTitle'),
}));

export const CategoryCollisionManagerMessage = Locales((i18n) => ({
	COLLISION_MESSAGE: (filename: string) =>
		i18n('i18n.categoryCollisionManagerMessage', {filename}),
}));

export const CategoryCollisionManagerActionLabel = Locales((i18n) => ({
	CANCEL: i18n('i18n.cancel'),
	SKIP: i18n('i18n.skip'),
	SUBMIT: i18n('i18n.continue'),
}));

export const CategoryOrganizeAssetsLabel = Locales((i18n) => ({
	[OrganizeAssetsAction.ADD]: i18n('i18n.add'),
	[OrganizeAssetsAction.MOVE]: i18n('i18n.move'),
	[OrganizeAssetsAction.REMOVE]: i18n('i18n.remove'),
	EDIT: i18n('i18n.save'),
}));

type OrganizeAssetsActionMessagesParams = {
	count: number;
	categoryName: string;
	fromCategoryName?: string;
	toCategoryName: string;
	isEdit?: boolean;
};
export const CategoryOrganizeAssetsSuccessMessages = Locales((i18n) => ({
	[OrganizeAssetsAction.ADD]: (params: OrganizeAssetsActionMessagesParams) =>
		i18n('i18n.assetsOrganizeAddSuccess', params),
	[OrganizeAssetsAction.MOVE]: (params: OrganizeAssetsActionMessagesParams) =>
		i18n('i18n.assetsOrganizeMoveSuccess', params),
	[OrganizeAssetsAction.REMOVE]: (params: OrganizeAssetsActionMessagesParams) =>
		i18n('i18n.assetsOrganizeRemoveSuccess', params),
}));

export const CategoryOrganizeAssetsErrorMessages = Locales((i18n) => ({
	[OrganizeAssetsAction.ADD]: (params: OrganizeAssetsActionMessagesParams) =>
		i18n('i18n.assetsOrganizeAddError', params),
	[OrganizeAssetsAction.MOVE]: (params: OrganizeAssetsActionMessagesParams) =>
		i18n('i18n.assetsOrganizeMoveError', params),
	[OrganizeAssetsAction.REMOVE]: (params: OrganizeAssetsActionMessagesParams) =>
		i18n('i18n.assetsOrganizeRemoveError', params),
}));
